import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import WarningFilledIcon from 'components/Common/Icons/WarningFilled'
import {
  Title,
  Subtitle,
  ProductWrapper,
  ImageWrapper,
  Image,
  InfoWrapper,
  InfoWrapperTitle,
  InfoWrapperSubtitle,
} from '../_styles'

interface UnrecognizedStateProps {
  images: string[]
  imageCount: number
  onImageClick: (images: string[]) => void
  renderImageCounter: (count: number) => React.ReactNode
  testIdPrefix?: string
}

const UnrecognizedState: FC<UnrecognizedStateProps> = ({
  images,
  imageCount,
  onImageClick,
  renderImageCounter,
  testIdPrefix,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Title>
        <WarningFilledIcon size={20} color={'var(--color-orange)'} />
        <span>{t('accountSetup.recognitionResult.productUnrecognized')}</span>
      </Title>
      <Subtitle>
        {t('capturedWines.dialog.updateImages.notRecognized.subtitle')}
      </Subtitle>
      <ProductWrapper
        data-testid={
          testIdPrefix ? `${testIdPrefix}-unrecognized-product` : undefined
        }
      >
        <ImageWrapper>
          <Image
            onClick={() => onImageClick(images)}
            src={images[0]}
            alt='Uploaded bottle images'
            data-testid={
              testIdPrefix ? `${testIdPrefix}-unrecognized-image` : undefined
            }
          />
          {renderImageCounter(imageCount)}
        </ImageWrapper>
        <InfoWrapper>
          <InfoWrapperTitle>
            {t('accountSetup.recognitionResult.wineRecognition')}
          </InfoWrapperTitle>
          <InfoWrapperSubtitle>
            {t('accountSetup.recognitionResult.wineRecognitionDesc')}
          </InfoWrapperSubtitle>
        </InfoWrapper>
      </ProductWrapper>
    </>
  )
}

export default UnrecognizedState
